import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

import { Pelicula } from '../models/pelicula';
import { PeliculaService } from '../services/pelicula.service';
@Component({
  selector: 'app-pelicula',
  templateUrl: './pelicula.component.html',
  styleUrls: ['./pelicula.component.css']
})
export class PeliculaComponent implements OnInit {

  model: Pelicula = new Pelicula();
  url = environment.imgUrl;

  constructor(private modelService: PeliculaService, private route: ActivatedRoute) {
    this.model.id = Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnInit() {
    this.modelService.get(this.model.id).subscribe(val => {
      this.model = val;
    });
  }

}
